import ENDPOINT from 'constants/endPoint';
import axiosClient from 'utils/axios';

export default {
  async getSetting() {
    const path = ENDPOINT.SETTING;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
